<template>
  <div class="dropdown" >
    <button class="button" @click="show">
      <i class="fa fa-ellipsis" style="color: red"></i>
    </button>
    <div class="dropdown-content" :id=this.idDropdown>
      <slot>
      <!-- <div v-if="this.$props.type === 'Clientes'">  
          <button class="dropdown-item" @click="showAlert">
            <i class="fas fa-bars " ></i> Conciliar
          </button>
          <a  :href=descargarBoleta>
            <div class="dropdown-item" >
              <i class="fas fa-file-invoice-dollar" ></i> Descargar boleta
            </div>
          </a>
      </div> -->
        <div v-if="this.$props.type === 'Clientes'">
          <router-link :to="{ path: '/ClienteConciliaDetalleCliente', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-eye " ></i> Buscar cliente
          </router-link>  
          <a  :href=descargarBoleta>
            <div class="dropdown-item" >
              <i class="fas fa-file-invoice-dollar" ></i> Descargar Boleta
            </div>
          </a>
          <div class="dropdown-item-special">
            Activado
            <input
                :id="id"
                type="checkbox"
                v-model="checked"
                class="dropdown-checkbox"
                @change="activateUser()"
            />
            <label class="wrapper" :for="id">
              <span class="circle"></span>
            </label>
          </div>
        </div>
        <div v-if="this.$props.type !== 'Clientes' && this.$props.type !== 'UsuariosB2C' && this.$props.type !== 'conciliacion' && this.$props.type !== 'UsuariosB2B'">
        </div>
        <div v-if="this.$props.type === 'discount'">
          <router-link :to="{ path: '/Client/ShowDiscount', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-eye " ></i> Ver Detalle
          </router-link>
        </div>
        <div v-if="this.$props.type === 'discountAdmin'">
          <router-link :to="{ path: '/Admin/ShowDiscount', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-eye " ></i> Ver Detalle
          </router-link>  
        </div>
        <div v-if="this.$props.type === 'adminClienteB2B'">
          <router-link :to="{ path: '/AdminAddUserB2B', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-eye " ></i> Editar
          </router-link>
        </div>
        <div v-if="this.$props.type === 'adminClienteB2C'">
          <router-link :to="{ path: '/AdminAddUserB2C', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-eye " ></i> Ver detalle
          </router-link>
        </div>
        <div v-if="this.$props.type === 'product'">
          <router-link :to="{ path: '/Client/showproduct', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-eye " ></i> Ver Detalle
          </router-link>
        </div>
        <div v-if="this.$props.type === 'productAdmin'">
          <router-link :to="{ path: '/Admin/showproduct', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-eye " ></i> Ver Detalle
          </router-link>
        </div>
        <div v-if="this.$props.type === 'branchoffice'">
          <router-link :to="{ path: '/Admin/showbranchoffice', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-eye " ></i> Ver Detalle
          </router-link>
        </div>
        <div v-if="this.$props.type === 'Operativo'">
          <router-link :to="{ path: '/ShowOperativoContable', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-eye " ></i> Ver Detalle
          </router-link>
        </div>
        <div @mouseleave="show('id-dropdown-content'+this.$props.id )"   v-if="this.$props.type === 'incidencia'">
          <router-link :to="{ path: '/IncidenciaAdminDetaller', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-eye " ></i> Ver Detalle
          </router-link>
        </div>
        <div v-if="this.$props.type === 'incidenciaAdmin'">
          <router-link :to="{ path: '/ShowIncidenceAdmin', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-eye " ></i> Ver Detalle
          </router-link>
        </div>
        <div  @mouseleave="show('id-dropdown-content'+this.$props.id )"  v-if="this.$props.type === 'BuzonSugerencias'">
          <router-link :to="{ path: '/BuzonSugerenciaAdminDetalle', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-eye " ></i> Ver Detalle
          </router-link>
        </div>
        <div v-if="this.$props.type === 'ClienteBoletaAcction'">
          <router-link :to="{ path: '/ProductDetalleCliente', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="fa fa-shopping-bag"></i> Detalle de Producto
          </router-link>
          <router-link :to="{ path: '/ClienteConciliaDetalleCliente', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-user-circle"></i> Buscar cliente
          </router-link>
          <a id="link" :href=descargarBoleta>
            <div class="dropdown-item" >
              <i class="fa fa-search"></i>Buscar boleta
            </div>
          </a>
          <div class="dropdown-item-special">
            Activado
            <input
                :id="id"
                type="checkbox"
                v-model="checked"
                class="dropdown-checkbox"
                @change="activeInvoice()"
            />
            <label class="wrapper" :for="id">
              <span class="circle"></span>
            </label>
          </div>
          <!--          <router-link :to="{ path: '/Client/showproduct', query: { id: this.$props.id }}" class="dropdown-item">-->
          <!--            <i class="far fa-eye " ></i> Ver Detalle-->
          <!--          </router-link>-->
        </div>
        <div v-if="this.$props.type === 'conciliacion'">
          <button class="dropdown-item" @click="showAlert">
            <i class="fas fa-bars " ></i> Conciliar
          </button>
          <router-link :to="{ path: '/ClienteConciliaDetalleCliente', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-eye " ></i> Buscar cliente
          </router-link>
          <a id="link" :href=descargarBoleta>
            <div class="dropdown-item" >
              <i class="fas fa-bars " ></i> Descargar boleta
            </div>
          </a>
<!--          <router-link :to="{ path: '/Client/showproduct', query: { id: this.$props.id }}" class="dropdown-item">-->
<!--            <i class="far fa-eye " ></i> Ver Detalle-->
<!--          </router-link>-->
        </div>
        <div v-if="this.$props.type === 'BranchOffice'">
          <button class="dropdown-item"  @click="showModalFron()">
            <i class="fas fa-bars"></i> Desplegar modal
          </button>
          <router-link :to="{ path: '/Client/ShowBranchOffice', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-eye " ></i> Ver Detalle
          </router-link>
          <div class="dropdown-item-special">
            Activado
            <input
                :id="id"
                type="checkbox"
                v-model="checked"
                class="dropdown-checkbox"
                @change="activateBranchOffice()"
            />
            <label class="wrapper" :for="id">
              <span class="circle"></span>
            </label>
          </div>
        </div>
        <div v-if="this.$props.type === 'SocioComercial'">
          <router-link :to="{ path: '/branchoffice', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-eye " ></i> Ver Detalle
          </router-link>
        </div>
        <div v-if="this.$props.type === 'UsuariosB2C'">
          <button class="dropdown-item" @click="showAlertUsuariosB2C">
            <i class="fas fa-bars " ></i> Restablecer contraseña
          </button>
        </div>
        <div v-if="this.$props.type === 'EditUsuariosB2C'">
          <button class="dropdown-item" @click="showAlertUsuariosB2C">
            <i class="fas fa-bars " ></i> Restablecer contraseña
          </button>
          <div class="dropdown-item-special">
            Activado
            <input
                :id="id"
                type="checkbox"
                v-model="checked"
                class="dropdown-checkbox"
                @change="activateUser()"
            />
            <label class="wrapper" :for="id">
              <span class="circle"></span>
            </label>
          </div>
        </div>
        <div v-if="this.$props.type === 'UsuariosB2B'">
          <router-link :to="{ path: '/AdminAddClientB2C', query: { id: this.$props.id }}" class="dropdown-item">
            <i class="far fa-eye " ></i> Editar
          </router-link>
          <button class="dropdown-item" >
            <i class="fas fa-bars " ></i> Activar y desactivar
          </button>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import axios from "axios";

  export default {
    props: {
      id: {
        type: Number,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        showModal: false,
        checked: false,
        showDropdwon: true,
        idDropdown: 'id-dropdown-content',
        axiosData: null,
        descargarBoleta: ''
      }
    },
    created() {
      this.idDropdown = this.idDropdown + this.$props.id
      if (this.$props.type === 'BranchOffice' ||  this.$props.type === 'EditUsuariosB2C'){
        this.GetBranchOfficeStatus()
      }
      this.descargarBoleta= axios.defaults.baseURL + "general/download/invoice/" + this.$props.id
    }, 
    methods:{
      closeModal () {
        this.showModal = false
      },
      showModalFron() {
        this.showModal = true;
        localStorage.setItem('modal', true)
        window.dispatchEvent(new CustomEvent('foo-key-localstorage-changed', {
          detail: {
            modal: true,
            id: this.$props.id
          }
        }));
      },
      async showAlertUsuariosB2C(){
        const { value: confirmButtonText } = await this.$swal.fire({
          title: 'Restablecer contraseña',
          icon: 'warning',
          text: 'Está por Restablecer contraseña de este usuario, ¿Desea confirmar la acción?',
          confirmButtonText: 'Restablecer contraseña',
          cancelButtonText: 'Cancelar',
          showCancelButton: true,
          showCloseButton: true
        })
        if (confirmButtonText === true){
          await axios.put("general/users/reset-password/"+this.$props.id).then((response) => {
            this.$swal.fire({
              title: 'Reseteo de password realizado',
              icon: 'success',
              showCloseButton: true
            })
          }).catch((error) => {
            this.$swal.fire({
              title: 'No se pudo resetear el password ',
              icon: 'error',
              showCloseButton: true
            })
              })
        }
      },
      async DescargarBoleta(){
        await axios.get("general/download/invoice/"+this.$props.id).then((response) => {
        })
      },
      async showAlert(){
        const { value: confirmButtonText } = await this.$swal.fire({
          title: 'Conciliar',
          icon: 'warning',
          text: 'Está por conciliar este item, ¿Desea confirmar la acción?',
          confirmButtonText: 'Conciliar',
          cancelButtonText: 'Cancelar',
          showCancelButton: true,
          showCloseButton: true
        })
        if (confirmButtonText === true){
          axios.put("general/conciliation/unit/"+this.$props.id)
          await this.$swal.fire({
            title: 'Conciliar realizada',
            icon: 'success',
            showCloseButton: true
          })
        }
      },
      async GetBranchOfficeStatus(){
        if ('EditUsuariosB2C'!== this.$props.type){
          let result = await axios.get("general/branchoffice/"+this.$props.id).then(res => {
            if (res.data.data.branch_status === 1){
              this.checked = true
            }else {
              this.checked = false
            }
            this.axiosData = res.data.data

          })
        }else {
          const valores = window.location.search;
          const urlParams = new URLSearchParams(valores);
          const id = urlParams.get('id');
          const { data } = await axios.get('general/users/b2busers/'+id,{
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          });
          var temp = data.data.data
          temp.forEach(item=>{
            if (item.id === this.$props.id){
              if (item.user_status === 1){
                this.checked = true
              }else {
                this.checked = false
              }
            }
          })
        }

      },
      activadeClient(){
      var data = null   
        if(this.checked === true){
          data = {
            "client_status": 1
          }
        }else{
          data = {
            "client_status": 0
          }
        }
        axios.put('general/client/'+this.$props.id, data)
      },
      activeInvoice(){
        var data = null
        if(this.checked === true){
          data = {
            "invoice_status": 1
          }
        }else{
          data = {
            "invoice_status": 0
          }
        }
        axios.put('general/invoice/'+this.$props.id, data)
      },
      activateUser(){
        var data = null
        if(this.checked === true){
          data = {
            "user_status": 1
          }
        }else {
          data = {
            "user_status": 0
          }
        }
        axios.put('user/'+this.$props.id, data)
      },
      activateBranchOffice(){
        var data = null
        if(this.checked === true){
           data = {
            branch_code: this.axiosData.branch_code,
            branch_name: this.axiosData.branch_name,
            branch_nickname: this.axiosData.branch_nickname,
            branch_description: this.axiosData.branch_description,
            branch_direction: this.axiosData.branch_direction,
            branch_reference: this.axiosData.branch_reference,
            branch_inside_mall: this.axiosData.branch_inside_mall,
            branch_dep_id: this.axiosData.branch_dep_id,
            branch_pro_id: this.axiosData.branch_pro_id,
            branch_dis_id: this.axiosData.branch_dis_id,
            ubigeo: this.axiosData.ubigeo,
            branch_latitude: this.axiosData.branch_latitude,
            branch_length: this.axiosData.branch_length,
            branch_status: 1
          }
        }else {
          data = {
            branch_code: this.axiosData.branch_code,
            branch_name: this.axiosData.branch_name,
            branch_nickname: this.axiosData.branch_nickname,
            branch_description: this.axiosData.branch_description,
            branch_direction: this.axiosData.branch_direction,
            branch_reference: this.axiosData.branch_reference,
            branch_inside_mall: this.axiosData.branch_inside_mall,
            branch_dep_id: this.axiosData.branch_dep_id,
            branch_pro_id: this.axiosData.branch_pro_id,
            branch_dis_id: this.axiosData.branch_dis_id,
            ubigeo: this.axiosData.ubigeo,
            branch_latitude: this.axiosData.branch_latitude,
            branch_length: this.axiosData.branch_length,
            branch_status: 0
          }
        }
        axios.put('general/branchoffice/'+this.$props.id, data)
      },
      show(){
        if (this.showDropdwon){
          document.getElementById(this.idDropdown).style.display = 'block'
          this.showDropdwon = false
        }else {
          document.getElementById(this.idDropdown).style.display = ''
          this.showDropdwon = true
        }
      }
    }
  }
</script>

<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}
.modal__action {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 1rem 0 0;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
  .dropdown {
    display: flex;
    margin: 10px 0;
    font-weight: 300;
    position: relative;
    align-items: center;
    width: calc(100% / 7);
    justify-content: center;
  }

  .dropdown-content {

  }

  /*.dropdown:hover .dropdown-content {*/
  /*  display: block;*/
  /*}*/
  .button {
    background: none;
    border: 0;
    color: inherit;
    outline:none;
  }

  .dropdown-item {
    height: 50px;
    display: flex;
    cursor: pointer;
    align-items: center;
  }

  .dropdown-item:active {
    color: inherit;
    background-color: inherit;
  }

  .dropdown-item svg {
    color: red;
    font-size: 1.2rem;
    margin-right: 0.8rem;
  }

  .dropdown-item-special {
    height: 60px;
    display: flex;
    padding: 1rem;
    font-weight: 400;
    align-items: center;
    justify-content: flex-end;
    border-top: 1px solid #cbcbcb;
  }

  .dropdown-checkbox {
    display: none;
  }

  .dropdown-checkbox:checked + .wrapper {
    background-color: #32ba7c;
  }

  .dropdown-checkbox:checked + .wrapper > .circle {
    left: 15px;
  }

  .wrapper {
    width: 31px;
    height: 16px;
    cursor: pointer;
    margin-bottom: 0;
    margin-left: 1rem;
    position: relative;
    border-radius: 30px;
    background-color: #cbcbcb;
  }

  .circle {
    left: 0;
    width: 15px;
    height: 15px;
    transition: 0.2s;
    position: absolute;
    border-radius: 50%;
    background-color: #fff;
  }
</style>
